import { apps } from '../rolesAndPermission';

export const movePaymentModule = {
  payments: {
    id: 43,
    moduleName: 'Payments',
  },
} as const;

export const movePaymentFeatures = {
  'move-payment': {
    id: 232,
    createdBy: 'System',
    featureName: 'Move Payment',
  },
} as const;

export const movePaymentFeaturesList = Object.entries(movePaymentFeatures).map(([key, v]) => ({
  key,
  ...v,
}));

export const movePaymentModules = [{ appId: apps.dashboard.id, moduleId: movePaymentModule['payments'].id }];

export const movePaymentModuleFeatures = [
  { moduleId: movePaymentModule['payments'].id, featureId: movePaymentFeatures['move-payment'].id },
];
